/**
 * Convenience hook: returns the `User` from the cached Supabase session.
 *
 * Prefer this over `supabase.auth.getUser()` in render paths — it reads
 * from React Query's in-memory cache instead of triggering a network call
 * on every mount.
 */
import type { User } from "@supabase/supabase-js";

import { useSession } from "@/hooks/auth/useSession";

export function useCurrentUser(): { user: User | null; isLoading: boolean } {
  const { data: session, isLoading } = useSession();
  return { user: session?.user ?? null, isLoading };
}
